import { FormattedMessage } from 'react-intl';
import { Col, Row, Statistic } from 'antd';
import { useColorScheme } from '@/contexts/ColorSchemeContextProvider';
import formatterPrice from '@/utils/number/formatterPrice';
import DiscountInfo from './DiscountInfo';

interface WorkOrderItemsSummaryProps {
  partTotal?: number;
  serviceTotal?: number;
  total?: number;
  totalDiscountPart?: number;
  totalDiscountService?: number;
  totalDiscountPartPercent?: number;
  totalDiscountServicePercent?: number;
}

function WorkOrderItemsSummary({
  partTotal,
  serviceTotal,
  total,
  totalDiscountPart,
  totalDiscountService,
  totalDiscountPartPercent,
  totalDiscountServicePercent,
}: WorkOrderItemsSummaryProps) {
  const [colorScheme] = useColorScheme();

  const baseTextColor = colorScheme === 'light' ? '#364068' : '#fff';

  const totalBase =
    (partTotal || 0) +
    (serviceTotal || 0) +
    (totalDiscountPart || 0) +
    (totalDiscountService || 0);
  const totalDiscount = (totalDiscountPart || 0) + (totalDiscountService || 0);

  const totalDiscountPercent = totalBase > 0 ? totalDiscount / totalBase : 0;

  return (
    <Row style={{ marginTop: 24 }} gutter={24}>
      <Col flex="1">
        <Statistic
          title={<FormattedMessage id="workOrders.details.items.partTotal" />}
          valueRender={() => formatterPrice(partTotal || 0)}
          style={{ whiteSpace: 'nowrap' }}
          valueStyle={{ color: baseTextColor }}
        />

        <DiscountInfo
          total={partTotal}
          percent={totalDiscountPartPercent}
          value={totalDiscountPart}
        />
      </Col>

      <Col flex="1">
        <Statistic
          title={
            <FormattedMessage id="workOrders.details.items.serviceTotal" />
          }
          valueRender={() => formatterPrice(serviceTotal || 0)}
          valueStyle={{ color: baseTextColor }}
          style={{ whiteSpace: 'nowrap' }}
        />

        <DiscountInfo
          total={serviceTotal}
          percent={totalDiscountServicePercent}
          value={totalDiscountService}
        />
      </Col>

      <Col flex="1">
        <Statistic
          title={<FormattedMessage id="workOrders.details.items.total" />}
          valueRender={() => formatterPrice(total || 0)}
          valueStyle={{ color: '#38B3CA' }}
          style={{ whiteSpace: 'nowrap' }}
        />

        <DiscountInfo
          total={(partTotal || 0) + (serviceTotal || 0)}
          percent={totalDiscountPercent}
          value={totalDiscount}
        />
      </Col>
    </Row>
  );
}

export default WorkOrderItemsSummary;
